import { render, staticRenderFns } from "./TheWheel.vue?vue&type=template&id=0c3797c0&scoped=true"
import script from "./TheWheel.vue?vue&type=script&lang=js"
export * from "./TheWheel.vue?vue&type=script&lang=js"
import style0 from "./TheWheel.vue?vue&type=style&index=0&id=0c3797c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3797c0",
  null
  
)

export default component.exports